import type {BoxPlotFragment} from './fragments/box-plot-fragment';
import type {CardResult, _CardResult} from './card-result';
import type {Card} from './card';
import type {_UnivariateCard} from './univariate-card';

/**
 * Generated from com.dataiku.dip.eda.worksheets.cards.SignTest1SampCard
 */
export interface SignTest1SampCard extends _UnivariateCard {
    confidenceLevel: number;
    hypothesizedMedian: number;

    // PolyJson type
    type: 'sign_test_1samp';
}

export namespace SignTest1SampCard {
    export const type = 'sign_test_1samp';
}

/** @deprecated Use Card.isSignTest1SampCard() */ export function isSignTest1SampCard(toTest: Card): toTest is SignTest1SampCard { return SignTest1SampCard.type === toTest['type']; }

export namespace SignTest1SampCard {
    /**
     * Generated from com.dataiku.dip.eda.worksheets.cards.SignTest1SampCard$SignTest1SampCardResult
     */
    export interface SignTest1SampCardResult extends _CardResult {
        boxPlot: BoxPlotFragment;
        nbLarger: number;
        nbSmaller: number;
        pvalue: number;

        // PolyJson type
        type: 'sign_test_1samp';
    }

    export namespace SignTest1SampCardResult {
        export const type = 'sign_test_1samp';
    }

    /** @deprecated Use CardResult.isSignTest1SampCardResult() */ export function isSignTest1SampCardResult(toTest: CardResult): toTest is SignTest1SampCardResult { return SignTest1SampCardResult.type === toTest['type']; }
}